import { render, staticRenderFns } from "./InfosSection.vue?vue&type=template&id=63de5c9c&scoped=true&"
import script from "./InfosSection.vue?vue&type=script&lang=js&"
export * from "./InfosSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de5c9c",
  null
  
)

/* custom blocks */
import block0 from "./InfosSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports